import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared/supportedMethods';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  BaseBackResponse,
  Technician,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.repairer}technician`;

const upsertTechnicianCommand = async (
  payload: Technician,
): Promise<BaseBackResponse | BackResponseFailure> => {
  try {
    const response = await apiCall<BackResponse<Technician>>(ENDPOINT, {
      method: SUPPORTED_METHODS.POST,
      json: payload,
    });

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
};

export default upsertTechnicianCommand;
